// @ts-check

import { createWidget } from "@opendash/core";



export default createWidget({
  type: "opendash-widget-bcm-project-tasks",
  meta: {},
  displayComponent: () => import("./component"),
  settingsComponent: () => import("./settings"),
  presets: [
    {
      label: "bcm:widgets.project-tasks.name",
      description: "bcm:widgets.project-tasks.description",
      imageLink: require("./screenshot.png"),
      layout: [8, 8],
      widget: {
        config: {},
      },
    },
  ],
});
